import PageTemplate from "../../templates/Template";

// DashboardPage for sekretariat
export const DashboardPage = (props) => {
  return (
    <PageTemplate title="Dashboard" menu="dashboard" isDrawerOpen={props.isDrawerOpen} setIsDrawerOpen={props.setIsDrawerOpen}>
      <p>This is the main dashboard for sekretariat</p>
    </PageTemplate>
  )
};